import React, { useState } from 'react'
import classNames from 'classnames'
import styles from './index.module.scss'
import PropTypes from 'prop-types'
import AddFeeFields from './AddFeeFields'

export default function AddFeesCard ({ asset, feeTypes, form, assetIndex }) {
  const ticketFeePresent = !asset && !!form?.getState()?.values?.ticketFees?.length
  const [accordionOpen, setAccordionOpen] = useState(ticketFeePresent)
  const toggleAccordion = () => {
    setAccordionOpen(prev => !prev)
  }
  return (
    <div
      className={classNames(styles.addFeesContainer, 'dis-rounded-panel dis-panel-body dis-form-container')}>
      <button
        type='button'
        onClick={toggleAccordion}
        className='dis-flex-page-title'>
        <div className='dis-list-item-header'>Add Fee Details</div>
        <i className={classNames([styles.icon, 'material-icons'])}>{accordionOpen ? 'expand_less' : 'expand_more'}</i>
      </button>
      {accordionOpen &&
        <div className={styles.feeFieldsContainer}>
          <AddFeeFields
            asset={asset}
            feeTypes={feeTypes}
            form={form}
            assetIndex={assetIndex}
          />
        </div>
      }
    </div>
  )
}

AddFeesCard.propTypes = {
  asset: PropTypes.string,
  feeTypes: PropTypes.array.isRequired,
  form: PropTypes.object.isRequired,
  assetIndex: PropTypes.number
}
